module.exports = __webpack_public_path__ + "static/media/primary-button-fill.6fcbb35c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/primary-button-fill.svg
// module id = 981
// module chunks = 0